module.exports = __webpack_public_path__ + "img/triangle_about_top.34b0355e.png";